// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer .explanation {
    line-height: 1.6em;
    margin-bottom: 2em;
}
footer a:link, footer a:active, footer a:visited {
    color: var(--header-text-color);
    font-style: normal;
}

footer a:hover {
    color: var(--header-text-highlight-color);
}

@media (800px <= width) {
    footer {
        padding: 50px 0;
        border-top: thin solid var(--header-border-color);
        background-color: var(--header-background-color);
        color: var(--header-text-color);
        font-style: italic;
    }
    footer .wrapper {
        margin: 0 auto;
        max-width: 1200px;
        width: 100%;
        text-align: center; 

        display: grid;
        grid-template-columns: 400px auto auto;

    }
}

@media (width < 800px) {
    footer {
        padding: 20px 10px;
        border-top: thin solid var(--header-border-color);
        background-color: var(--header-background-color);
        color: var(--header-text-color);
        font-style: italic;
    }
    footer .wrapper {
        margin: 0 auto;
        width: 100%;
        text-align: center; 
    }

    footer .footer__block {
        padding: 10px 0;
    }
}
`, "",{"version":3,"sources":["webpack://./client/components/header/Footer.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI;QACI,eAAe;QACf,iDAAiD;QACjD,gDAAgD;QAChD,+BAA+B;QAC/B,kBAAkB;IACtB;IACA;QACI,cAAc;QACd,iBAAiB;QACjB,WAAW;QACX,kBAAkB;;QAElB,aAAa;QACb,sCAAsC;;IAE1C;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,iDAAiD;QACjD,gDAAgD;QAChD,+BAA+B;QAC/B,kBAAkB;IACtB;IACA;QACI,cAAc;QACd,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["footer .explanation {\n    line-height: 1.6em;\n    margin-bottom: 2em;\n}\nfooter a:link, footer a:active, footer a:visited {\n    color: var(--header-text-color);\n    font-style: normal;\n}\n\nfooter a:hover {\n    color: var(--header-text-highlight-color);\n}\n\n@media (800px <= width) {\n    footer {\n        padding: 50px 0;\n        border-top: thin solid var(--header-border-color);\n        background-color: var(--header-background-color);\n        color: var(--header-text-color);\n        font-style: italic;\n    }\n    footer .wrapper {\n        margin: 0 auto;\n        max-width: 1200px;\n        width: 100%;\n        text-align: center; \n\n        display: grid;\n        grid-template-columns: 400px auto auto;\n\n    }\n}\n\n@media (width < 800px) {\n    footer {\n        padding: 20px 10px;\n        border-top: thin solid var(--header-border-color);\n        background-color: var(--header-background-color);\n        color: var(--header-text-color);\n        font-style: italic;\n    }\n    footer .wrapper {\n        margin: 0 auto;\n        width: 100%;\n        text-align: center; \n    }\n\n    footer .footer__block {\n        padding: 10px 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
